define([], function () {
    var modes = {
        DEVELOPMENT: "DEVELOPMENT",
        PRODUCTION: "PRODUCTION"
    };

    Object.freeze(modes);

    return modes;
});
//# sourceMappingURL=Modes.js.map
